import {CONSTANTS} from '@/constants';
import { functions } from '@/functions';

export const functions_city = {

    data: function () {
        return {
            cities:[],
        };
    },
    computed: {
    },

    methods: {
        /*
        *   Список городов
        */

        loadCities: function (onSuccess=null, param=null) {
            if (!this.isCitiesLoaded()) {
                this.cities_loaded = false;
                this.httpPrepare();
                this.$http.get(this.apiurl('city/a')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.cities = response.payload;
                    this.cities_loaded = true;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetCities: function () {
            this.cities = [];
            return this;
        },

        isCitiesLoaded: function () {
            return (this.cities !== null) && this.cities.length && this.cities_loaded;
        },
    }

};

